import { Card, Result, Button, Typography, Space } from 'antd';
import { WifiOutlined, ReloadOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';

const { Text, Link } = Typography;

const ErrorComponent = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      padding: '20px'
    }}>
      <Card style={{ maxWidth: 450, textAlign: 'center' }}>
        <Result
          status="error"
          title="Connection Error"
          subTitle="We can't reach our servers right now."
          icon={<img src="/logo.png" alt="Oops" style={{ width: 60 }} />}
          extra={
            <Space direction="vertical" style={{ width: '100%' }}>
              <Text type="secondary">
                This might be a temporary outage, maintenance, or an issue with your internet connection.
              </Text>
              
              <div style={{ margin: '20px 0' }}>
                <Button 
                  type="primary" 
                  size="large" 
                  icon={<ReloadOutlined />}
                  onClick={() => window.location.reload()}
                  style={{ marginBottom: '16px' }}
                >
                  Try Again
                </Button>
                
                <div style={{ fontSize: '14px', marginBottom: '8px' }}>
                  <WifiOutlined /> Check your internet connection
                </div>
              </div>

              <Text type="secondary">
                If the problem persist, please contact us:
              </Text>
              
              <Space direction="horizontal" size="middle">
                <Link href="tel:+27815901227">
                  <PhoneOutlined /> +27 815901227
                </Link>
                <Link href="mailto:ask@tanaka.co.za">
                  <MailOutlined /> ask@tanaka.co.za
                </Link>
              </Space>
            </Space>
          }
        />
      </Card>
    </div>
  );
};

export default ErrorComponent;